// ABOUTME: Application root with layout-based routing
// ABOUTME: PublicLayout for landing/auth, AppLayout for authenticated pages

import { lazy, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import ProtectedRoute from '@/components/auth/ProtectedRoute'
import ErrorBoundary from '@/components/ErrorBoundary'
import AppLayout from '@/components/layout/AppLayout'
import PublicLayout from '@/components/layout/PublicLayout'
import ScrollToTop from '@/components/layout/ScrollToTop'
import LandingPage from '@/pages/LandingPage'

const Auth = lazy(() => import('@/pages/Auth'))
const Help = lazy(() => import('@/pages/Help'))
const HomePage = lazy(() => import('@/pages/HomePage'))
const Wardrobe = lazy(() => import('@/pages/Wardrobe'))
const Scanner = lazy(() => import('@/pages/Scanner'))
const OutfitBuilder = lazy(() => import('@/pages/OutfitBuilder'))
const Education = lazy(() => import('@/pages/Education'))
const Challenges = lazy(() => import('@/pages/Challenges'))
const Profile = lazy(() => import('@/pages/Profile'))
const Onboarding = lazy(() => import('@/pages/Onboarding'))
const Insights = lazy(() => import('@/pages/Insights'))
const Shop = lazy(() => import('@/pages/Shop'))
const AICoach = lazy(() => import('@/pages/AICoach'))
const Progress = lazy(() => import('@/pages/Progress'))
const Leaderboard = lazy(() => import('@/pages/Leaderboard'))
const Avatar = lazy(() => import('@/pages/Avatar'))
const ColorProfile = lazy(() => import('@/pages/ColorProfile'))
const Subscription = lazy(() => import('@/pages/Subscription'))
const Preview = lazy(() => import('@/pages/Preview'))
const More = lazy(() => import('@/pages/More'))

function PageLoader() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <p className="text-fg-tertiary text-sm">Loading...</p>
    </div>
  )
}

export default function App() {
  return (
    <ErrorBoundary>
      <ScrollToTop />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<LandingPage />} />
            <Route path="/auth" element={<Auth />} />
          </Route>

          <Route path="/help" element={<Help />} />

          <Route element={<AppLayout />}>
            <Route path="/home" element={<HomePage />} />
            <Route path="/wardrobe" element={<Wardrobe />} />
            <Route path="/scanner" element={<Scanner />} />
            <Route path="/outfit-builder" element={<OutfitBuilder />} />
            <Route path="/education" element={<Education />} />
            <Route path="/challenges" element={<Challenges />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/ai-coach" element={<AICoach />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/progress" element={<Progress />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/avatar" element={<Avatar />} />
            <Route path="/color-profile" element={<ColorProfile />} />
            <Route path="/subscription" element={<Subscription />} />
            <Route path="/more" element={<More />} />
          </Route>

          <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
          <Route path="/preview/:type/:id" element={<ProtectedRoute><Preview /></ProtectedRoute>} />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  )
}
